<template>
  <div :key="master_key"
       class="h-100">
    <div class="search">
      <search :o="$data"></search>
    </div>
    <div class="d-flex p-1 pb-2 header"
         style="height: 45px">
      <div class="d-flex filters align-items-center mr-2 position-relative">
        <i class="fas fa-filter text-secondary mr-2" aria-hidden="true"></i>
        <div class="filter-dropdown-wrapper"
             ref="filterDropdownWrapper">
          <button class="btn btn-outline-secondary btn-sm filter-dropdown-btn"
                  @click="toggleFilterDropdown()">
            <span v-if="activeFilterCount === 0">All Billing Types</span>
            <span v-else>Filters ({{ activeFilterCount }})</span>
            <i class="fas fa-chevron-down ml-2"></i>
          </button>
          <div v-if="filterDropdownOpen" class="filter-dropdown-menu">
            <div class="filter-columns">
              <div class="filter-column">
                <!-- Schedule Section -->
                <div class="filter-section">
                  <div class="filter-section-title">Schedule</div>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="schedule"
                           :value="null"
                           v-model="selectedFilters.schedule"
                           @change="handleFilterChange()">
                    <span>Any</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="schedule"
                           value="Monthly"
                           v-model="selectedFilters.schedule"
                           @change="handleFilterChange()">
                    <span>Monthly</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="schedule"
                           value="Quarterly"
                           v-model="selectedFilters.schedule"
                           @change="handleFilterChange()">
                    <span>Quarterly</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="schedule"
                           value="Semi-Annually"
                           v-model="selectedFilters.schedule"
                           @change="handleFilterChange()">
                    <span>Semi-Annually</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="schedule"
                           value="Annually"
                           v-model="selectedFilters.schedule"
                           @change="handleFilterChange()">
                    <span>Annually</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio"
                           name="schedule"
                           value="Quarterly 2"
                           v-model="selectedFilters.schedule"
                           @change="handleFilterChange()">
                    <span>Quarterly 2</span>
                  </label>
                </div>

                <!-- Type Section -->
                <div class="filter-section">
                  <div class="filter-section-title">Type</div>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="type"
                           :value="null"
                           v-model="selectedFilters.type"
                           @change="handleFilterChange()">
                    <span>Any</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="type"
                           value="advance"
                           v-model="selectedFilters.type"
                           @change="handleFilterChange()">
                    <span>Advance</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="type"
                           value="arrears"
                           v-model="selectedFilters.type"
                           @change="handleFilterChange()">
                    <span>Arrears</span>
                  </label>
                </div>
              </div>
              
              <div class="filter-column">
                <!-- Billing Status Section -->
                <div class="filter-section">
                  <div class="filter-section-title">Billing Status</div>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="billingStatus"
                           :value="null"
                           v-model="selectedFilters.billingStatus"
                           @change="handleFilterChange()">
                    <span>Any</span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="billingStatus"
                           value="ready"
                           v-model="selectedFilters.billingStatus"
                           @change="handleFilterChange()">
                    <span><span class="filter-badge badge-ready">Ready</span></span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="billingStatus"
                           value="billed"
                           v-model="selectedFilters.billingStatus"
                           @change="handleFilterChange()">
                    <span><span class="filter-badge badge-billed">Billed</span></span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="billingStatus"
                           value="paid"
                           v-model="selectedFilters.billingStatus"
                           @change="handleFilterChange()">
                    <span><span class="filter-badge badge-paid">Paid</span></span>
                  </label>
                  <label class="filter-radio">
                    <input type="radio" 
                           name="billingStatus"
                           value="none"
                           v-model="selectedFilters.billingStatus"
                           @change="handleFilterChange()">
                    <span>-- (No Status)</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex actions my-auto pl-2">
        <template v-if="hasSelection">
          <div title="Create Invoice"
               class="btn btn-outline-secondary"
               v-on:click="click('invoice-bulk')">
            <i class="fas fa-file-invoice-dollar"></i>
            <span class="ml-1">Bulk Invoice</span>
          </div>
          <div :title="title('discloseFeeScheduleBulk')"
               class="btn btn-outline-secondary"
               v-on:click="click('discloseFeeScheduleBulk')">
            <i class="fas fa-mail-bulk"></i>
            <span class="ml-1">Disclose Fee Schedule</span>
          </div>
          <!-- disclose annual amendment -->
          <div :title="title('discloseAnnualAmendment')"
               class="btn btn-outline-secondary"
               v-on:click="click('discloseAnnualAmendment')">
            <i class="fas fa-mail-bulk"></i>
            <span class="ml-1">Disclose Annual Amendment</span>
          </div>
        </template>
        <template v-else>
          <div class="d-flex my-auto mr-2 pr-1" >
            <span class="alt-action text-secondary">Select one or more contracts for options</span>
          </div>
        </template>
      </div>
      <div class="flex-grow-1 my-auto text-right" 
      style="display: flex; flex-direction: column; font-size: 0.8rem" >
        <span v-text="recordsSummary"></span>
        <span v-text="selectedSummary"></span>
      </div>
    </div>

    <template v-if="ready">
    <scroll-area class="pr-3">
      <a ref="download"
         class="d-none"></a>
      <table class="table table-sm">
        <thead>
          <tr>
            <th>
              <checkbox :o="selectAllState"
                        p="selected"
                        v-on:change="change()"></checkbox>
            </th>
            <th>
              <span>Id</span>
              <i class="fas fa-sort"
                 :class="sortClass(`id`)"
                 v-on:click="sort(`id`)"></i>
            </th>
            <th>
              <span>Ref</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`ref`)"
                 v-on:click="sort(`ref`)"></i>
            </th>
            <th>
              <span>Billing Type</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`billingType`)"
                 v-on:click="sort(`billingType`)"></i>
            </th>
            <th>
              <span>Billing Schedule</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`billingSchedule`)"
                 v-on:click="sort(`billingSchedule`)"></i>
            </th>
            <th class="text-nowrap">
              <span>Billing Status</span>
            </th>
            <th>
              <span>Accounts</span>
          <i class="fas fa-sort pl-1"
            :class="sortClass(`accounts`)"
            v-on:click="sort(`accounts`)"></i>
            </th>
            <th>
              <span>Schedules</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`schedules`)"
                 v-on:click="sort(`schedules`)"></i>
            </th>
            <th class="text-nowrap">
              <span>Date</span>
              <i class="fas fa-sort pl-1"
                 :class="sortClass(`date`)"
                 v-on:click="sort(`date`)"></i>
            </th>
            <th class="text-nowrap"></th>
          </tr>
        </thead>
        <tbody :key="bodyKey">
          <tr v-for="(o, index) in limitedItems"
              :key="o._id"
              data-cy="custodian-contract-row">
            <td>
              <checkbox :o="o"
                        p="select"
                        v-on:change="change(o)"
                        :disabled="o.status != `Active`"></checkbox>
            </td>
            <td>
              <a href="#" class="badge badge-custom"
                    :title="title(`contract`)"
                    v-on:click="click(`contract`, o)"
                    v-text="o.id"></a>
            </td>
            <td class="text-nowrap">
              <span>{{ o.ref.split("- ")[0] }}</span>
            </td>
            <td>
              <span style="text-transform: capitalize;">{{ o.billingType }}</span>
            </td>
            <td>
              <span style="text-transform: capitalize;">{{ o.billingSchedule || '-' }}</span>
            </td>
            <td class="text-nowrap">
              <div v-if="o.billingStatus" 
                   class="billing-status-tooltip"
                   :data-tooltip="getBillingStatusTooltip(o.billingStatus.badgeClass)">
                <span :class="`badge badge-${o.billingStatus.badgeClass}`"
                      v-text="o.billingStatus.label"></span>
              </div>
              <span v-else class="text-muted">-</span>
            </td>
            <td class="accounts">
              <div class="accounts-container">
                <span v-for="(a, i) in getVisibleAccounts(o)"
                      :key="i"
                      class="account-badge mr-2"
                      v-text="a"></span>
                <button v-if="o.accounts && o.accounts.length > 3"
                        @click="toggleAccountsExpanded(o._id)"
                        class="btn-expand-accounts">
                  {{ expandedAccounts[o._id] ? 'Show Less' : `+${o.accounts.length - 3} more` }}
                </button>
              </div>
            </td>
            <td class="schedules">
              <schedule-badges 
              :schedules="o.schedules" 
              @click="openScheduleModal"></schedule-badges>
            </td>
            <td class="text-nowrap">
              <span v-text="o.date"></span>
            </td>
            <td class="text-nowrap">
              <i class="far fa-file-pdf mr-2"
                 :title="title(`pdf`)"
                 v-on:click="click(`pdf`, o)"></i>
              <i class="fas fa-dollar-sign mr-2"
                 :title="title(`bill`)"
                 :class="o.status != `Active` ? `disabled` : ``"
                 v-on:click="o.status == `Active` ? click(`bill`, o) : ``"></i>
              <i class="far fa-paper-plane mr-2"
                 :title="title(`discloseFeeSchedule`)"
                 v-on:click="click(`discloseFeeSchedule`, o)"></i>
              <i v-if="o.showSignatureReminder" class="far fa-bell mr-2"
                 :title="title(`reminder`)"
                 v-on:click="click(`reminder`, o)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </scroll-area>
  </template>
  <template v-else>
      <loading></loading>
  </template>
  </div>
</template>

<style scoped>
th {
  white-space: nowrap;
}

i.disabled {
  cursor: not-allowed !important;
  opacity: 0.1 !important;
}

span.alt-action {
  font-weight: 200;
  font-style: italic;
  font-size: 0.8rem;
}

div.search {
  margin-right: 1em;
  margin-top: -3em;
  float: right;
  width: 15em;
}

div.header div.actions {
  cursor: pointer;
  font-size: 0.8rem;
  border-left: 1px solid lightgray;
}
div.header div.actions div {
  margin-right: 1em;
  cursor: pointer;
  font-size: 0.8rem;
}

div.header div.filters {
  align-items: center;
  margin-right: 1em;
}

table span {
  font-size: 0.9rem;
}

span.link {
  cursor: pointer;
  text-decoration: underline;
}

table th:nth-child(1) {
  width: 2em;
}

table th:nth-child(2) {
  width: 5em;
}

table th:nth-child(3) {
  width: 25%;
}

table th:nth-child(4) {
  width: auto;
}

table th:nth-child(5) {
  width: auto;
}

table th:nth-child(6) {
  width: 7em;
}

table th:nth-child(7) {
  width: 6em;
}

td.accounts div.accounts-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

td.accounts .account-badge {
  display: inline-block;
  font-size: 0.85rem;
  width: fit-content;
}

button.btn-expand-accounts {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  font-size: 0.85rem;
  text-decoration: underline;
  text-align: left;
  font-weight: normal;
}

td.accounts span,
td.schedules span {
  white-space: pre;
}

td {
  vertical-align: inherit;
}

i {
  opacity: 0.3;
}

i:hover,
i.sort,
i.active {
  cursor: pointer;
  opacity: 1;
}

span.badge {
  color: white;
  font-weight: normal;
  width: 5em;
}

span.schedule-badge {
  font-weight: normal;
  font-size: 0.8em;
  width: auto;
  cursor: pointer;
  text-decoration: none;
  transition: text-decoration 0.2s, color 0.2s;
}
span.schedule-badge:hover {
  text-decoration: underline;
  color: #007bff;
}

span.badge-paid {
  background-color: #6f42c1;
  color: white;
  font-weight: normal;
  width: auto;
}

span.badge-billed {
  background-color: #007bff;
  color: white;
  font-weight: normal;
  width: auto;
}

span.badge-ready {
  background-color: #28a745;
  color: white;
  font-weight: normal;
  width: auto;
}

i.active {
  color: red;
}

div.filters i.fa-filter {
  font-size: 0.85em;
  margin-right: 0.5em;
  cursor: default !important;
  opacity: 0.3;
}

.filter-dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.filter-dropdown-btn {
  white-space: nowrap;
  padding: 0.25rem 0.75rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}

.filter-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 2px;
  min-width: 420px;
}

.filter-columns {
  display: flex;
  flex-direction: row;
}

.filter-column {
  flex: 1;
  min-width: 200px;
}

.filter-column .filter-section {
  border-right: 1px solid #f0f0f0;
}

.filter-column:last-child .filter-section {
  border-right: none;
}

.filter-section {
  padding: 0.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.filter-section:last-child {
  border-bottom: none;
}

.filter-section-title {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6c757d;
  padding: 0.5rem 0.5rem 0.25rem;
  margin-bottom: 0.25rem;
}

.filter-radio {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.25rem;
  transition: background-color 0.2s;
}

.filter-radio:hover {
  background-color: #f8f9fa;
}

.filter-radio input[type="radio"] {
  margin-right: 0.5rem;
  cursor: pointer;
}

.filter-radio span {
  font-size: 0.9rem;
  user-select: none;
}

.filter-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.85rem;
  font-weight: normal;
  width: auto;
}

.billing-status-tooltip {
  position: relative;
  display: inline-block;
  cursor: help;
}

.billing-status-tooltip:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.5rem 0.75rem;
  background-color: #333;
  color: white;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: normal;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  text-transform: none;
}

.billing-status-tooltip:hover::before {
  content: '';
  position: absolute;
  bottom: 115%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #333;
  z-index: 1000;
}

</style>

<script>
import { scrollArea, search, checkbox, loading } from "../../../../component";
import ScheduleBadges from "../../../../component/schedule/schedule-badges.vue";

import { Api, List, Modal, Record } from "../../../../factory";
import { numeral } from "../../../../npm";
import { alert, events, session, getActiveScopeFilter } from "../../../../service";
import { startOfBillingQuarter, endOfBillingQuarter, isQuarterlySchedule, isOffCycleSchedule } from "../../../../service/off_cycle_billing";
import moment from "moment";

export default {
  name: `FirmContracts`,
  get components() {
    return {
      scrollArea,
      search,
      checkbox,
      ScheduleBadges,
      loading
    };
  },
  data() {
    return {
      selectedFilters: {
        schedule: null,
        type: null,
        billingStatus: null
      },
      filterDropdownOpen: false,
      selectedItems: {},
      search: ``,
      sortState: { asc: ``, key: `` },
      master_key: 0,
      ready: false,
      expandedAccounts: {},
      records: [],
      bodyKey: 0,
      selectAllState: { selected: false },
      renderLimit: 500,
      lastSearch: '',
    };
  },
  computed: {
    displayItems() {
      let items = this.records;
      // Apply billing filters
      if (this.selectedFilters.schedule !== null || this.selectedFilters.type !== null || this.selectedFilters.billingStatus !== null) {
        items = items.filter((item) => {
          if (this.selectedFilters.schedule !== null && item.billingSchedule?.toLowerCase() !== this.selectedFilters.schedule.toLowerCase()) return false;
          if (this.selectedFilters.type !== null && item.billingType?.toLowerCase() !== this.selectedFilters.type.toLowerCase()) return false;
          if (this.selectedFilters.billingStatus !== null) {
            if (this.selectedFilters.billingStatus === 'none') {
              if (item.billingStatus) return false;
            } else {
              if (!item.billingStatus || item.billingStatus.badgeClass !== this.selectedFilters.billingStatus) return false;
            }
          }
          return true;
        });
      }
      // Apply search
      if (this.search) {
        const terms = this.search.toLowerCase().split(' ');
        items = items.filter(item => {
          return terms.every(term => {
            const searchStr = `${item.id} ${item.ref} ${item.billingType || ''} ${item.billingSchedule || ''}`.toLowerCase();
            return searchStr.includes(term);
          });
        });
      }
      // Apply sort
      const { key, asc } = this.sortState;
      if (key) {
        items = [...items].sort((a, b) => {
          if (key === 'date') {
            return asc
              ? new Date(a[key]) - new Date(b[key])
              : new Date(b[key]) - new Date(a[key]);
          }
          return asc
            ? String(a[key]).localeCompare(String(b[key]))
            : String(b[key]).localeCompare(String(a[key]));
        });
      }
      return items;
    },
    limitedItems() {
      // Reset render window when search term changes so results start from the top
      if (this.search !== this.lastSearch) {
        this.renderLimit = 500;
        this.lastSearch = this.search;
      }
      return this.displayItems.slice(0, this.renderLimit);
    },
    activeFilterCount() {
      let count = 0;
      if (this.selectedFilters.schedule !== null) count++;
      if (this.selectedFilters.type !== null) count++;
      if (this.selectedFilters.billingStatus !== null) count++;
      return count;
    },
    recordsSummary() {
      return List.records(this.limitedItems, this.displayItems, this.records);
    },
    selectedSummary() {
      const selected = this.displayItems.filter(i => i.select);
      const total = this.displayItems.length;
      return `Selected ${numeral(selected.length).format('0,0')} of ${numeral(total).format('0,0')} record(s)`;
    },
    hasSelection() {
      return this.displayItems.some(el => el.select);
    },
  },
  created() {
    this.init();
    this._eventWatcher = events.$watch({
      modal: this.onModalEvent.bind(this),
    });
    this._scrollUid = events.$on('scroll', (e) => {
      const el = e?.data?.target;
      if (!el) return;
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 300) {
        if (this.renderLimit < this.displayItems.length) {
          this.renderLimit += 500;
        }
      }
    });
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
    events.$unwatch(this._eventWatcher);
    if (this._scrollUid) events.$off(this._scrollUid);
  },
  methods: {
    init() {
      this._loading = false;
      this.invoicesMap = {};
      this._contracts = [];
      this.loadData();
    },
    getVisibleAccounts(contract) {
      if (!contract.accounts || contract.accounts.length === 0) 
        return [];
      const limit = 3;
      if (this.expandedAccounts[contract._id]) 
        return contract.accounts;
      return contract.accounts.slice(0, limit);
    },
    toggleAccountsExpanded(contractId) {
      this.$set(this.expandedAccounts, contractId, !this.expandedAccounts[contractId]);
    },
    handleClickOutside(event) {
      const el = this.$refs.filterDropdownWrapper;
      if (el && !el.contains(event.target)) {
        this.filterDropdownOpen = false;
      }
    },
    openScheduleModal(schedule) {
      const allSchedules = session.get('FirmSchedules') || [];
      const fullSchedule = allSchedules.find(s => s.name === schedule);
      Modal.open('schedule', {
        schedule: fullSchedule,
        viewOnly: true,
        methods: {
          success: () => { Modal.close(); },
        },
      });
    },
    sortClass(key) {
      return this.sortState.key === key ? 'sort' : '';
    },
    statusBadgeClass(status) {
      const statuses = ['Pending', 'Signed', 'Active', 'Expired', 'Amended'];
      const badges = ['warning', 'success', 'primary', 'danger', 'warning'];
      const idx = statuses.indexOf(status);
      return `badge-${badges[idx] || 'secondary'}`;
    },
    title(type) {
      switch (type) {
        case 'contract': return 'View contract';
        case 'pdf': return 'Download contract';
        case 'bill': return 'Invoice contract';
        case 'discloseFeeSchedule': return 'Mail to client';
        case 'discloseFeeScheduleBulk': return 'Send fee schedule to selected clients';
        case 'discloseAnnualAmendment': return 'Send annual amendment to selected clients';
        case 'reminder': return 'Send signature reminder';
        default: return '';
      }
    },
    disabled(type) {
      return type === 'select' ? false : true;
    },
    sort(key) {
      const s = this.sortState;
      s.asc = s.key === key ? (typeof s.asc === 'boolean' ? !s.asc : true) : true;
      s.key = key;
      this.renderLimit = 500;
    },
    toggleFilterDropdown() {
      this.filterDropdownOpen = !this.filterDropdownOpen;
    },
    handleFilterChange() {
      this.renderLimit = 500;
      // Computed displayItems will automatically invalidate on selectedFilters change
      this.$nextTick(() => {
        this.selectAllState.selected = this.displayItems.length > 0 && this.displayItems.every(el => el.select);
      });
    },
    async loadData() {
      if (this._loading) return;
      this._loading = true;
      this.ready = false;
      try {
        const state = session.get('state');
        const invoicesPromise = this.fetchInvoicesForLastQuarter(state);
        const url = `contracts/list?status=2&firmId=${state.firm._id}${getActiveScopeFilter(state)}`;
        const contractsPromise = Api.get(url);
        const [invoicesMap, { data: contracts }] = await Promise.all([invoicesPromise, contractsPromise]);
        this.invoicesMap = invoicesMap;

        // Phase 1: Object.freeze() raw contracts to prevent deep reactivity
        const frozenContracts = contracts.map(c => Object.freeze({ ...c }));
        this._contracts = frozenContracts;

        // Pre-compute billing status and flat records at load time
        const items = await Promise.all(frozenContracts.map(async (contract) => {
          const contractInvoices = this.invoicesMap[contract._id] || [];
          const billingStatus = await this.calculateBillingStatus(contract, contractInvoices);
          const select = !!this.selectedItems[contract._id];
          return this.buildRecord(contract, billingStatus, select);
        }));
        items.sort((a, b) => b.date.localeCompare(a.date));
        this.records = items;
      } catch (e) {
        console.error(e);
      } finally {
        this._loading = false;
        this.ready = true;
      }
    },
    fetchInvoicesForLastQuarter(state) {
      try {
        const quarterStartDate = moment().subtract(3, 'months').startOf('month');
        const quarterEndDate = moment().endOf('month');
        const startTimestamp = Math.floor(quarterStartDate.valueOf() / 1000);
        const endTimestamp = Math.floor(quarterEndDate.valueOf() / 1000);
        const url = `invoices/list?startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}&firmId=${state.firm._id}${getActiveScopeFilter(state)}`;
        return Api.get(url).then(({ data: invoices }) => {
          // Use plain object instead of Map for Vue 2 compatibility
          const map = {};
          if (invoices && Array.isArray(invoices)) {
            invoices.forEach(invoice => {
              if (invoice.contractId) {
                if (!map[invoice.contractId]) map[invoice.contractId] = [];
                map[invoice.contractId].push(invoice);
              }
            });
          }
          return map;
        });
      } catch (error) {
        console.error('Error fetching invoices for last quarter:', error);
        return {};
      }
    },
    buildRecord(contract, billingStatus, select) {
      const accounts = (contract.accounts || []).map(a => a.number);
      const schedules = (contract.schedules || []).map(s => s.name);
      const id = Record.id(contract);
      const statuses = ['Pending', 'Signed', 'Active', 'Expired', 'Amended'];
      const status = statuses[contract.status] || 'Unknown';
      return {
        _id: contract._id,
        id,
        accounts,
        date: contract.date,
        ref: contract.ref,
        billingType: contract.billing?.type,
        billingSchedule: contract.billing?.schedule,
        billingStatus,
        lineItems: contract.lineItems,
        schedules,
        status,
        showSignatureReminder: contract.signing_request_id !== '' && contract.status === 0,
        select,
        // Keep minimal fields needed by other methods
        pdf: contract.pdf,
        signing_request_id: contract.signing_request_id,
        signees: contract.signees,
      };
    },
    async calculateBillingStatus(contract, invoices = []) {
      try {
        if (!invoices || invoices.length === 0) {
          return this.getBillingStatusReady(contract);
        }
        const sortedInvoices = [...invoices].sort((a, b) =>
          moment(b._created) - moment(a._created)
        );
        const mostRecentInvoice = sortedInvoices[0];
        if (this.isInCurrentBillingPeriod(mostRecentInvoice, contract)) {
          if (mostRecentInvoice.status === 1) {
            return { label: 'Paid', badgeClass: 'paid' };
          } else if (mostRecentInvoice.status === 0) {
            return { label: 'Billed', badgeClass: 'billed' };
          }
        }
        return this.getBillingStatusReady(contract);
      } catch (error) {
        console.error('Error calculating billing status:', error);
        return null;
      }
    },
    isInCurrentBillingPeriod(invoice, contract) {
      if (!invoice.period || !invoice.period.end) return false;
      const invoicePeriodEnd = moment(invoice.period.end, 'MM/DD/YYYY');
      const today = moment().startOf('day');
      const schedule = contract.billing?.schedule?.toLowerCase();
      if (schedule === 'monthly') return invoicePeriodEnd.isSame(today, 'month');
      if (isQuarterlySchedule(contract.billing?.schedule)) {
        const isOffCycle = isOffCycleSchedule(contract.billing?.schedule);

        let start, end;
        if (isOffCycle) {
          // OFF-CYCLE BILLING
          start = startOfBillingQuarter(today, contract.billing);
          end = endOfBillingQuarter(today, contract.billing);
        } else {
          // standard quarterly billing (original behaviour)
          start = today.clone().startOf('quarter');
          end = today.clone().endOf('quarter');
        }
        return invoicePeriodEnd.isBetween(start, end, 'day', '[]');
      }
      return false;
    },
    getBillingStatusReady(contract) {
      if (!contract.billing || !contract.billing.schedule) return null;
      const schedule = contract.billing.schedule.toLowerCase();
      const today = moment().startOf('day');
      if (schedule === 'monthly') {
        const daysUntilDue = today.daysInMonth() - today.date();
        return (daysUntilDue <= 5 && daysUntilDue >= 0)
          ? { label: 'Ready', badgeClass: 'ready' } : null;
      } else if (isQuarterlySchedule(contract.billing.schedule)) {
        const isOffCycle = isOffCycleSchedule(contract.billing.schedule);

        let dueDate;
        if (isOffCycle) {
          // OFF-CYCLE BILLING
          dueDate = endOfBillingQuarter(today, contract.billing);
        } else {
          // standard quarterly billing (original behaviour)
          dueDate = today.clone().endOf('quarter');
        }
        const daysUntilDue = dueDate.startOf('day').diff(today, 'days');
        return (daysUntilDue <= 15 && daysUntilDue >= 0)
          ? { label: 'Ready', badgeClass: 'ready' } : null;
      }
      return null;
    },
    getBillingStatusTooltip(statusClass) {
      switch (statusClass) {
        case 'paid': return 'Most recent invoice has been paid';
        case 'billed': return 'Invoice pending payment';
        case 'ready': return 'Ready to bill based on schedule';
        default: return '';
      }
    },
    async loadContractDetails(contract) {
      try {
        const { data } = await Api.get(`contracts?_id=${contract._id}`);
        return Array.isArray(data) ? data[0] : data;
      } catch (error) {
        console.error('Error loading contract details:', error);
        return contract;
      }
    },
    async downloadPdf(contract) {
      try {
        if (!contract.file) {
          if (!contract.pdf) return alert.warning('Sorry, this contract has no pdf?', 3e3);
          const { data: f } = await Api.get(`files?name=${encodeURIComponent(contract.pdf)}`);
          contract.file = f;
        }
        const el = this.$refs.download;
        el.setAttribute('href', contract.file.dataURI);
        el.setAttribute('download', contract.file.name);
        el.click();
        el.removeAttribute('href');
        el.removeAttribute('download');
      } catch (e) {
        console.error(e);
        alert.error(e.message);
      }
    },
    reload() {
      events.$emit('nav', 'contracts');
    },
    onModalEvent(e) {
      if (e.name === 'modal' && e.data?.action === 'hidden') {
        this.loadData();
      }
    },
    async click(type, d) {
      switch (type) {
        case 'bill':
          return this.click('invoice', d);
        case 'invoice':
          return Modal.open('invoice-create', {
            contract: (await Api.get(`contracts?_id=${d._id}`)).data,
            methods: {
              success: () => { Modal.close(); events.$emit('nav', 'invoices'); },
            },
          });
        case 'invoice-bulk': {
          const selectedIds = this.displayItems.filter(item => item.select).map(item => item._id);
          const selectedContracts = this._contracts.filter(c => selectedIds.includes(c._id));
          if (!selectedContracts.length) return alert.warning('No contracts selected!', 3e3);
          const hasAdvance = selectedContracts.some(c => c.billing?.type?.toLowerCase() === 'advance');
          const hasArrears = selectedContracts.some(c => c.billing?.type?.toLowerCase() === 'arrears');
          if (hasAdvance && hasArrears) {
            return alert.warning('Unable to run bulk billing for contracts both in advance and in arrears. Rerun either separately.', 5e3);
          }
          // Quarterly contracts on different cycles (e.g. standard Jan/Apr/Jul/Oct vs
          // Feb/May/Aug/Nov) must be billed as separate batches, otherwise the period
          // would be mis-calculated for one of them.
          const quarterlyCycles = [
            ...new Set(
              selectedContracts
                .filter(c => isQuarterlySchedule(c.billing?.schedule))
                .map(c => c.billing?.schedule),
            ),
          ];
          if (quarterlyCycles.length > 1) {
            return alert.warning(
              `Unable to run bulk billing for contract quarters on different cycles (${quarterlyCycles.join(' vs ')}). Rerun each cycle as its own batch.`,
              6e3,
            );
          }
          return Modal.open('invoice-bulk-create', {
            contracts: selectedContracts,
            methods: {
              success: () => { Modal.close(); events.$emit('nav', 'invoices'); },
            },
          });
        }
        case 'contract': {
          const loaded = await this.loadContractDetails(d);
          return Modal.open('contract', {
            contract: loaded,
            methods: {
              success: () => { Modal.close(); this.reload(); },
            },
          });
        }
        case 'pdf':
          return this.downloadPdf(d);
        case 'discloseAnnualAmendment': {
          const contracts = this.displayItems.filter(item => item.select).map(({ _id }) => ({ _id }));
          return this.discloseAnnualAmendment({ contracts });
        }
        case 'discloseFeeScheduleBulk': {
          const contracts = this.displayItems.filter(item => item.select).map(({ _id }) => ({ _id }));
          const household = contracts.length === 1
            ? (await Api.get(`households/by-contract-id?_id=${contracts[0]._id}`)).data
            : undefined;
          return this.discloseFeeScheduleModal({ contracts, household });
        }
        case 'discloseFeeSchedule': {
          const household = (await Api.get(`households/by-contract-id?_id=${d._id}`)).data;
          return this.discloseFeeScheduleModal({ contracts: [d._id], household });
        }
        case 'reminder':
          return this.sendReminder(d);
        default:
          throw new Error(`Invalid click type, ${type}!`);
      }
    },
    discloseFeeScheduleModal(data) {
      Modal.open('DiscloseFeeSchedule', {
        ...data,
        inEffect: true,
        methods: {
          send: async (formData) => {
            try {
              await Api.post('email/disclose-fee-arrangement', formData);
              alert.message('Fee arrangement sent!', 1500);
            } catch (error) {
              console.error(error);
              alert.error(error, 3000);
            }
            Modal.close();
          },
        },
      });
    },
    discloseAnnualAmendment(data) {
      const state = session.get('state');
      Modal.open('DiscloseAnnualAmendment', {
        ...data,
        is603: state.firm._id === '64272b169c5b3d23455c40e5',
        isSims: state.firm._id === '65ba36319193e93b765bd754',
        methods: {
          send: async (formData) => {
            try {
              await Api.post('email/disclose-annual-amendmentment', formData);
              alert.message('Annual amendment sent.', 1500);
            } catch (error) {
              console.error(error);
              alert.error(error, 3000);
            }
            Modal.close();
          },
        },
      });
    },
    sendReminder(d) {
      try {
        Api.post('/templates/remind', { signatureRequestId: d.signing_request_id, signees: d.signees });
        alert.message('Signature reminder was sent.', 1500);
      } catch (error) {
        console.error(error);
        alert.error('An error occurred while sending the reminder to the client.', 3000);
      }
    },
    change(item) {
      if (!item) {
        // Header checkbox: select/deselect all filtered items (not just visible batch)
        const items = this.displayItems;
        const allSelected = items.length > 0 && items.every(el => el.select);
        const newState = !allSelected;
        // Single pass over all filtered items to avoid double reactivity overhead
        for (let i = 0; i < items.length; i++) {
          items[i].select = newState;
          this.selectedItems[items[i]._id] = newState;
        }
      } else {
        // Individual row checkbox
        this.selectedItems[item._id] = item.select;
      }
      // Sync header checkbox state
      this.selectAllState.selected = this.displayItems.length > 0 && this.displayItems.every(el => el.select);
    },
  },
};
</script>
